import { Stack } from "@mui/material";
import { useNavHeader } from "../../Shared/Header/useNavHeader";
import { Button } from "@src/appV2/redesign/components/Button";
import { IconButton } from "@src/appV2/redesign/components/IconButton";
import { NotificationsCenterDrawer } from "@src/appV2/redesign/AppLayout/Shared/NotificationsCenterDrawer";
import { Badge } from "@src/appV2/redesign/components/Badge";
import { useIsRebrand } from "@src/appV2/redesign/theme/RebrandProvider";

interface NavigationMenuFooterMobileProps {
  closeSidenav: () => void;
}

export function NavigationMenuFooterMobile(props: NavigationMenuFooterMobileProps) {
  const { closeSidenav } = props;
  const isRebrand = useIsRebrand();
  const {
    displayHelpButton,
    iconTypeHelpButton,
    onClickHelpButton,

    displayNotificationsButton,
    iconTypeNotificationsButton,
    unreadNotificationCount,
    notificationsCenterModalState,
    onClickNotificationsButton,

    displaySettingsButton,
    iconTypeSettingsButton,
    onClickSettingsButton,
  } = useNavHeader();

  return (
    <>
      <Stack
        flexGrow={1}
        flexShrink={1}
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        {displayHelpButton && (
          <Button
            variant={isRebrand ? "link" : "linkInverted"}
            endIconType={iconTypeHelpButton}
            onClick={() => {
              onClickHelpButton();
              closeSidenav();
            }}
          >
            Help
          </Button>
        )}

        {(displaySettingsButton || displayNotificationsButton) && (
          <Stack direction="row" gap={3}>
            {displaySettingsButton && (
              <IconButton
                variant={isRebrand ? "link" : "linkInverted"}
                iconType={iconTypeSettingsButton}
                onClick={() => {
                  onClickSettingsButton();
                  closeSidenav();
                }}
              />
            )}

            {displayNotificationsButton && (
              <Badge count={unreadNotificationCount}>
                <IconButton
                  variant={isRebrand ? "link" : "linkInverted"}
                  iconType={iconTypeNotificationsButton}
                  onClick={onClickNotificationsButton}
                />
              </Badge>
            )}
          </Stack>
        )}
      </Stack>
      <NotificationsCenterDrawer modalState={notificationsCenterModalState} />
    </>
  );
}
